import React from 'react';

import { Image } from './wrapper';

interface Props {
  image: string;
  alt?: string;
}

const Avatar = ({ image, alt }: Props) => <Image src={image} alt={alt} />;

export default Avatar;
